import React from 'react';
import './Loader.scss';

function Loader(props) {

  return (
    <div className={'Loader ' + props.size + ' ' + (props.active === 0 ? '' : 'Active')}>
        <div id="loadingCircle"></div>
        <div>Loading...</div>
    </div>
  );
}

export default Loader;